exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Control {\n  display: flex; }\n  .Control > label {\n    flex-basis: 30%; }\n  .Control .controlItem {\n    flex-basis: 70%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/style/Control.scss
// module id = 1708
// module chunks = 0